import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[content]",
})
export class GenericContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
